"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var step_1 = require("../step");
var mobx_1 = require("mobx");
var inversify_react_1 = require("inversify-react");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var ApiService_1 = require("CreatePageFlow/ApiService");
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var CreatePageTelemetry_1 = __importDefault(require("../CreatePageTelemetry"));
var ExpandableText_1 = __importDefault(require("../CreatePageComponents/ExpandableText"));
var types_1 = require("CreatePageFlow/types");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var lodash_1 = require("lodash");
var utils_2 = require("../utils");
var FolderStorageKey = "createPage.lastUsedFolder";
var c = (0, BemBuilder_1.default)("create-page-flow-pre-bake");
var PreBake = (function (_super) {
    __extends(PreBake, _super);
    function PreBake(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.errorMessage = _this.props.store.creatingPageError || "";
        _this.openTokenInfo = false;
        _this.folders = { status: FetchUtils_1.RemoteDataStatus.NotRequested };
        _this.isFolderDropdownOpen = false;
        _this.currentFolder = { id: localStorage.getItem(FolderStorageKey) || "", name: "" };
        _this.rootFolderName = "Pages Folder";
        _this.images = {
            configureIcon: "".concat(types_1.ASSETS_DIR, "Images/createPage/configureIcon.svg"),
        };
        _this.refreshFolders = function (addingFolder) { return __awaiter(_this, void 0, Promise, function () {
            var result, folders, currentFolder, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.folders.status === FetchUtils_1.RemoteDataStatus.Loading) {
                            return [2];
                        }
                        if (!addingFolder) {
                            this.setFolders({ status: FetchUtils_1.RemoteDataStatus.Loading });
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.apiService.getFolders()];
                    case 2:
                        result = _a.sent();
                        folders = result.map(function (folder) {
                            var newFolder = {
                                id: folder.id,
                                name: folder.name,
                                parent: folder.ancestors.length ? folder.ancestors[folder.ancestors.length - 1] : "",
                            };
                            return newFolder;
                        });
                        this.setFolders({ status: FetchUtils_1.RemoteDataStatus.Success, data: folders });
                        currentFolder = folders.find(function (folder) { return folder.id === _this.currentFolder.id; });
                        this.setCurrentFolder(currentFolder);
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setFolders({
                            status: FetchUtils_1.RemoteDataStatus.Error,
                            error: new Error("Something went wrong while loading folders. Please try again."),
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        _this.createSubstitutionsCallback = function () { return __awaiter(_this, void 0, void 0, function () {
            var resolvedTokens, substitutions;
            var _this = this;
            return __generator(this, function (_a) {
                resolvedTokens = this.props.store.resolvedTokens.resolvedTokens;
                substitutions = {};
                (0, lodash_1.mapValues)(resolvedTokens, function (tokenResult, key) {
                    var resolvedValue = tokenResult.value;
                    if ((0, lodash_1.isString)(resolvedValue) || (0, lodash_1.isNumber)(resolvedValue)) {
                        substitutions[key] = resolvedValue;
                    }
                    else if (Array.isArray(resolvedValue)) {
                        substitutions[key] = resolvedValue.map(_this.makeSubstitutions);
                    }
                });
                this.props.store.setSubstitutions(substitutions);
                this.props.moveStep(1);
                return [2];
            });
        }); };
        _this.moveStepForward = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.moveStep(1);
                return [2];
            });
        }); };
        _this.makeSubstitutions = function (record) {
            return (0, lodash_1.mapValues)(record, function (tokenResult) {
                return tokenResult.value;
            });
        };
        _this.focusRef = react_1.default.createRef();
        _this.openTokenInfoBox = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.telemetry.tokenResolutionDataToggled(this.openTokenInfo, Object.keys(this.props.store.resolvedTokens.unresolvedTokens).length);
                this.setOpenTokenInfo(!this.openTokenInfo);
                setTimeout(function () {
                    if (_this.focusRef.current) {
                        _this.focusRef.current.scrollIntoView({ behavior: "smooth" });
                    }
                }, kaleidoscope_2.AnimationDuration.Long);
                return [2];
            });
        }); };
        _this.handleTitleChange = function (pageTitle) {
            _this.props.store.setPageTitle(pageTitle);
        };
        _this.selectFolder = function (folderId) {
            if (_this.folders.status === FetchUtils_1.RemoteDataStatus.Success) {
                var selectedFolder = _this.folders.data.find(function (folder) { return folder.id === folderId; });
                _this.setCurrentFolder(selectedFolder);
            }
            try {
                localStorage.setItem(FolderStorageKey, folderId);
            }
            catch (_a) { }
            _this.setIsFolderDropdownOpen(false);
        };
        _this.addFolder = function (folderName, location) { return __awaiter(_this, void 0, Promise, function () {
            var id, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!folderName) return [3, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, this.apiService.createFolder(folderName, location)];
                    case 2:
                        id = (_a.sent()).id;
                        this.telemetry.newFolderCreated(folderName);
                        return [4, this.refreshFolders(true)];
                    case 3:
                        _a.sent();
                        return [2, id];
                    case 4:
                        e_2 = _a.sent();
                        this.setFolders({
                            status: FetchUtils_1.RemoteDataStatus.Error,
                            error: new Error("Something went wrong while loading folders. Please try again."),
                        });
                        return [3, 5];
                    case 5: return [2, this.currentFolder.id];
                }
            });
        }); };
        _this.flattenResolvedTokens = function (tokens) {
            return (0, lodash_1.flatMap)(Object.values(tokens), function (resolvedToken) {
                if (Array.isArray(resolvedToken.value)) {
                    return (0, lodash_1.flatMap)(resolvedToken.value, Object.values);
                }
                return resolvedToken;
            });
        };
        _this.flattenUnresolvedTokens = function (resolvedTokens) {
            return (0, lodash_1.flatMap)(Object.values(resolvedTokens), function (unresolvedToken) {
                if ((0, lodash_1.isObject)(unresolvedToken.errorCode)) {
                    return Object.values(unresolvedToken.errorCode).map(function (t) { return ({
                        tokenName: t.tokenName,
                        errorCode: t.errorCode,
                        errorMessage: unresolvedToken.errorMessage,
                    }); });
                }
                return {
                    tokenName: unresolvedToken.tokenName,
                    errorCode: unresolvedToken.errorCode,
                    errorMessage: unresolvedToken.errorMessage,
                };
            });
        };
        _this.isStringOrNumberTokenResult = function (token) {
            return (0, lodash_1.isString)(token.value) || (0, lodash_1.isNumber)(token.value);
        };
        _this.isProductTokenResult = function (token) {
            return Array.isArray(token.value);
        };
        props.store.setPageTitle((_a = props.store.template.name) !== null && _a !== void 0 ? _a : "Untitled");
        _this.onClickOutsideMenu = new utils_1.OnClickOutside([".".concat(c("folder-button")), ".folder-dropdown"], function () {
            _this.setIsFolderDropdownOpen(false);
        });
        return _this;
    }
    PreBake.prototype.componentDidMount = function () {
        this.refreshFolders();
    };
    PreBake.prototype.setCurrentFolder = function (folder) {
        if (folder) {
            if (folder.name != this.currentFolder.name) {
                this.telemetry.outputFolderChanged(folder.name);
            }
            this.currentFolder = { id: folder.id, name: folder.name };
            this.props.store.setFolderId(folder.id);
        }
        else {
            this.currentFolder = { id: "", name: this.rootFolderName };
            this.props.store.setFolderId(null);
        }
    };
    PreBake.prototype.setFolders = function (folders) {
        this.folders = folders;
    };
    PreBake.prototype.setIsFolderDropdownOpen = function (isOpen) {
        this.isFolderDropdownOpen = isOpen;
        if (isOpen)
            this.onClickOutsideMenu.startListening();
        else
            this.onClickOutsideMenu.stopListening();
    };
    PreBake.prototype.setErrorMessage = function (errorMessage) {
        this.errorMessage = errorMessage;
    };
    PreBake.prototype.setOpenTokenInfo = function (openTokenInfo) {
        this.openTokenInfo = openTokenInfo;
    };
    PreBake.prototype.renderTitleInput = function () {
        var _this = this;
        return (react_1.default.createElement(kaleidoscope_1.TextInput, { autoFocus: true, size: kaleidoscope_1.TextInputSize.Large, label: "Page title", value: this.props.store.pageTitle, onChange: this.handleTitleChange, onBlur: function () {
                if (_this.props.store.pageTitle)
                    _this.telemetry.pageTitleEdited(_this.props.store.pageTitle);
            } }));
    };
    PreBake.prototype.renderFolderHandling = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: c("folder-button") },
            react_1.default.createElement("div", { className: "space-stack-s" },
                react_1.default.createElement(kaleidoscope_1.Label, { size: "s", long: true }, "Choose a Folder")),
            react_1.default.createElement(kaleidoscope_1.Button, { className: c("button"), type: kaleidoscope_1.ButtonType.Secondary, width: "full", size: kaleidoscope_1.ButtonSize.Large, disabled: this.folders.status !== FetchUtils_1.RemoteDataStatus.Success, buttonState: this.folders.status === FetchUtils_1.RemoteDataStatus.Loading ? kaleidoscope_1.ButtonState.Waiting : kaleidoscope_1.ButtonState.Idle, onClick: function () { return _this.setIsFolderDropdownOpen(!_this.isFolderDropdownOpen); } },
                react_1.default.createElement("div", { className: c("folder-icon") },
                    react_1.default.createElement("div", { className: c("folder-icon-folder") },
                        react_1.default.createElement(icons_1.Folder, null))),
                react_1.default.createElement("div", { className: c("folder-button-text") }, this.currentFolder.name)),
            this.isFolderDropdownOpen && (react_1.default.createElement(kaleidoscope_1.FolderDropdown, { folders: this.folders, onSelect: this.selectFolder, onAddFolder: this.addFolder, initialFolderId: this.currentFolder.id, rootFolderName: this.rootFolderName }))));
    };
    PreBake.prototype.renderCreatePageButton = function (onClickCallback) {
        return (react_1.default.createElement(kaleidoscope_1.Button, { className: (0, classnames_1.default)(c("create-page-button"), { "margin-transition": this.openTokenInfo == true }), type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Large, onClick: onClickCallback, buttonState: kaleidoscope_1.ButtonState.Idle }, "Create page"));
    };
    PreBake.prototype.render = function () {
        var _this = this;
        var store = this.props.store;
        if (this.props.store.integrationName && (0, utils_2.isPlatformSupportedIntegration)(this.props.store.integrationName)) {
            var resolvedTokens = store.resolvedTokens.resolvedTokens || {};
            var unresolvedTokens_1 = this.flattenUnresolvedTokens(store.resolvedTokens.unresolvedTokens) || [];
            var stringOrNumberTokens_1 = Object.values(resolvedTokens).filter(this.isStringOrNumberTokenResult);
            var lineItems_1 = Object.values(resolvedTokens).filter(this.isProductTokenResult);
            var isMultipleUnresolvedTokens_1 = unresolvedTokens_1.length > 1;
            var numResolvedTokens_1 = this.flattenResolvedTokens(resolvedTokens).length;
            return (react_1.default.createElement("div", { className: c() },
                react_1.default.createElement("img", { className: c("icon"), src: this.images.configureIcon, alt: "" }),
                react_1.default.createElement("div", { className: "space-stack-s" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "2" }, "Configure")),
                react_1.default.createElement("div", { className: c("description") },
                    react_1.default.createElement("div", { className: "space-stack-m" },
                        react_1.default.createElement(kaleidoscope_1.Text, null, "Set your page title and output folder, or check your token data."))),
                react_1.default.createElement("div", { className: c("form") },
                    this.renderTitleInput(),
                    this.renderFolderHandling(),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "space-stack-s" },
                            react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, "Token Data")),
                        react_1.default.createElement(kaleidoscope_1.Button, { className: (0, classnames_1.default)(c("button"), "tokens-dropdown"), type: kaleidoscope_1.ButtonType.Secondary, width: "full", onClick: this.openTokenInfoBox, size: kaleidoscope_1.ButtonSize.Large, buttonState: kaleidoscope_1.ButtonState.Idle },
                            react_1.default.createElement(react_1.default.Fragment, null, numResolvedTokens_1 + unresolvedTokens_1.length
                                ? "Fetched ".concat(numResolvedTokens_1, " token").concat(numResolvedTokens_1 != 1 ? "s" : "", ", ").concat(unresolvedTokens_1.length, " missing.")
                                : "0 tokens found."),
                            react_1.default.createElement(icons_1.ChevronRight, { className: this.openTokenInfo ? "tokens-dropdown__down" : "tokens-dropdown__right" })))),
                react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: this.openTokenInfo, element: kaleidoscope_1.Card, className: c("token-section"), timeout: kaleidoscope_2.AnimationDuration.Long }, function (_a) {
                    var expandableElementRef = _a.expandableElementRef;
                    return (react_1.default.createElement("div", { ref: expandableElementRef },
                        react_1.default.createElement("div", { className: c("tokens-wrapper"), ref: _this.focusRef }, numResolvedTokens_1 + unresolvedTokens_1.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                            unresolvedTokens_1.length > 0 && (react_1.default.createElement("div", { className: c("token-box") },
                                react_1.default.createElement("div", { className: "space-stack-s" },
                                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" },
                                        "Empty token",
                                        isMultipleUnresolvedTokens_1 ? "s" : "")),
                                react_1.default.createElement("div", { className: "space-stack-l" },
                                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", secondary: true },
                                        "We couldn't find data for ",
                                        react_1.default.createElement("b", null, unresolvedTokens_1.length),
                                        " token",
                                        isMultipleUnresolvedTokens_1 ? "s" : "",
                                        ".",
                                        isMultipleUnresolvedTokens_1 ? " They" : " It",
                                        "'ll be blank when you create your page. Don't worry, you can always hop in and edit your page after it's been created.")),
                                react_1.default.createElement("table", { className: c("token-table") },
                                    react_1.default.createElement("thead", null,
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", { className: c("token-table-header-cell") },
                                                react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, "Missing Fields")),
                                            react_1.default.createElement("th", { className: c("token-table-header-cell") }))),
                                    react_1.default.createElement("tbody", null, unresolvedTokens_1.map(function (_a) {
                                        var tokenName = _a.tokenName, errorCode = _a.errorCode, errorMessage = _a.errorMessage;
                                        return (react_1.default.createElement("tr", { key: tokenName },
                                            react_1.default.createElement("td", { className: c("token-table-cell") },
                                                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, tokenName)),
                                            react_1.default.createElement("td", { className: c("token-table-cell") },
                                                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, errorCode === Types_1.TokenResolutionErrorCode.TOKEN_DEPRECATED
                                                    ? errorMessage !== null && errorMessage !== void 0 ? errorMessage : "This token has been deprecated. Please remove it and try-again."
                                                    : ""))));
                                    }))))),
                            numResolvedTokens_1 > 0 && (react_1.default.createElement("div", { className: c("token-box") },
                                react_1.default.createElement("div", { className: "space-stack-s" },
                                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "Token data")),
                                react_1.default.createElement("div", { className: "space-stack-s" },
                                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", secondary: true }, "This is the data we found matching the tokens in your selected template:")),
                                stringOrNumberTokens_1.length > 0 && (react_1.default.createElement("table", { className: c("token-table") },
                                    react_1.default.createElement("thead", null,
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", { className: c("token-table-header-cell") },
                                                react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, "Field")),
                                            react_1.default.createElement("th", { className: c("token-table-header-cell") },
                                                react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, "Value")))),
                                    react_1.default.createElement("tbody", null, stringOrNumberTokens_1.map(function (token, i) { return (react_1.default.createElement("tr", { key: i },
                                        react_1.default.createElement("td", { className: c("token-table-cell") },
                                            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, token.tokenName)),
                                        react_1.default.createElement("td", { className: c("token-table-cell") },
                                            react_1.default.createElement(ExpandableText_1.default, { size: "xs", text: String(token.value) })))); })))),
                                lineItems_1.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(kaleidoscope_1.Text, { className: c("line-item-heading"), size: "s", strong: true }, "Product Line Items"),
                                    react_1.default.createElement("div", { className: "space-stack-s" },
                                        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", secondary: true }, "If your quote block uses filters, the items below will be filtered on your created page")),
                                    Object.values(lineItems_1[0].value).map(function (itemsList, i) { return (react_1.default.createElement("table", { className: (0, classnames_1.default)(c("token-table"), "product-tokens"), key: i },
                                        react_1.default.createElement("tbody", null, Object.values(itemsList).map(function (item, j) { return (react_1.default.createElement("tr", { key: j },
                                            react_1.default.createElement("td", { className: c("token-table-cell") },
                                                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, item.tokenName)),
                                            react_1.default.createElement("td", { className: c("token-table-cell") },
                                                react_1.default.createElement(ExpandableText_1.default, { size: "xs", text: String(item.value) })))); })))); }))))))) : (react_1.default.createElement("div", { className: c("token-box") },
                            react_1.default.createElement("div", { className: "space-stack-s" },
                                react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "No tokens found")),
                            react_1.default.createElement("div", { className: "space-stack-l" },
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "No tokens were found in your selected template. Proceed without tokens or edit your template to add tokens.")))))));
                }),
                this.errorMessage && (react_1.default.createElement(kaleidoscope_1.Alert, { className: c("error"), alertType: kaleidoscope_1.AlertType.Error, heading: "Error" }, this.errorMessage)),
                this.renderCreatePageButton(this.createSubstitutionsCallback)));
        }
        else {
            return (react_1.default.createElement("div", { className: c() },
                react_1.default.createElement("div", { className: "space-stack-m" },
                    react_1.default.createElement("div", { className: c("title") },
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "3" }, "Page details"))),
                react_1.default.createElement("div", { className: c("form") },
                    this.renderTitleInput(),
                    !this.props.store.skipFolderSelection && this.renderFolderHandling()),
                this.errorMessage && (react_1.default.createElement(kaleidoscope_1.Alert, { className: c("error"), alertType: kaleidoscope_1.AlertType.Error, heading: "Error" }, this.errorMessage)),
                react_1.default.createElement("div", { className: c("button-wrapper") }, this.renderCreatePageButton(this.moveStepForward))));
        }
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof ApiService_1.ApiService !== "undefined" && ApiService_1.ApiService) === "function" ? _b : Object)
    ], PreBake.prototype, "apiService", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_c = typeof CreatePageTelemetry_1.default !== "undefined" && CreatePageTelemetry_1.default) === "function" ? _c : Object)
    ], PreBake.prototype, "telemetry", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], PreBake.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PreBake.prototype, "openTokenInfo", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_d = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _d : Object)
    ], PreBake.prototype, "folders", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PreBake.prototype, "isFolderDropdownOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], PreBake.prototype, "currentFolder", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PreBake.prototype, "setCurrentFolder", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], PreBake.prototype, "setFolders", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PreBake.prototype, "setIsFolderDropdownOpen", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PreBake.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PreBake.prototype, "setOpenTokenInfo", null);
    PreBake = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_a = typeof step_1.StepProps !== "undefined" && step_1.StepProps) === "function" ? _a : Object])
    ], PreBake);
    return PreBake;
}(react_1.default.Component));
exports.default = PreBake;
